const runtimeDefaults = (designTemp: number) => {
  if (typeof designTemp != undefined && designTemp && designTemp > 0) return 16;

  return 18;
};

export default { runtimeDefaults };
